<script setup lang="ts">
import type { Article_Plain } from '@webamboos/admin'

defineProps<{
  article: Article_Plain
}>()

const { formatDate } = useDate()

const localePath = useLocalePath()
</script>

<template>
  <NuxtLink
    :to="localePath(`/blog/${article.slug}`)"
    class="hover:bordershadow-lg-gray group flex flex-col gap-4 rounded-lg p-2 transition hover:bg-black/5 md:flex-row md:items-end md:gap-4 lg:gap-6"
  >
    <div class="h-full w-full">
      <NuxtImg
        :src="article.image.url"
        :alt="article.image.name"
        :width="640"
        :height="400"
        class="bordershadow-gray h-full w-full rounded object-cover transition"
      />
    </div>

    <div
      class="bordershadow-gray group absolute bottom-4 left-4 right-2 flex w-[calc(100%-2rem)] flex-col rounded bg-black/50 p-4 text-white backdrop-blur-sm md:px-8 md:py-6"
    >
      <Paragraph
        size="small"
        class="mb-0 hidden max-h-0 overflow-hidden text-white opacity-0 transition-all duration-300 group-hover:mb-4 group-hover:max-h-6 group-hover:opacity-100 sm:flex"
      >
        <time class="flex items-center gap-1">
          <div v-if="article.category" class="flex items-center gap-1">
            <span class="text-main-50 font-medium">{{ article.category.name }} </span>
            <span>—</span>
          </div>
          {{ formatDate(article?.publishedAt as Date) }}
        </time>
      </Paragraph>

      <Heading as="h2" size="medium" class="mb-0 text-white transition-all group-hover:md:mb-2">
        {{ article.title }}
      </Heading>

      <Paragraph
        size="normal"
        class="line-clamp-3 hidden max-h-0 overflow-hidden text-white transition-all duration-300 group-hover:max-h-32 sm:flex"
      >
        {{ article.description }}
      </Paragraph>

      <span
        class="group mt-0 hidden max-h-0 items-center gap-x-2 overflow-hidden font-medium text-white transition-all duration-300 group-hover:mt-4 group-hover:max-h-4 sm:flex"
      >
        {{ $t('blog.read_more') }}
        <Icon name="lucide:move-right" />
      </span>
    </div>
  </NuxtLink>
</template>
